<div>
	<div class="ibox-title">
		<h5>Todays Visitees for {{ Title }}</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="Inited == false || (loading == true && lstVisitee.length == 0)">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Table-->
		<div class="table-main-body" *ngIf="Inited == true && lstVisitee.length > 0">
			<p-table
				#mydt
				[value]="lstVisitee"
				[loading]="loading"
				[paginator]="true"
				[(rows)]="pagerows"
				[(first)]="pagefirst"
				[showCurrentPageReport]="true"
				[resizableColumns]="false"
				sortMode="multiple"
				styleClass="p-datatable-striped"
				selectionMode="single"
				[(selection)]="SelectedVisitee"
				dataKey="ID"
				(onRowSelect)="onRowSelect($event)"
				(onRowUnselect)="onRowUnselect($event)"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
				[rowsPerPageOptions]="[5, 10, 25, 50]"
			>
				<!--Headers-->
				<ng-template pTemplate="header">
					<!--Filter or Select from Dropdown-->
					<tr>
						<!--INSERT CUSTOM FILTERS HERE-->

						<!--VisiteeName-->
						<th>
							<p-columnFilter type="text" field="VisiteeName" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--Email-->
						<th>
							<p-columnFilter type="text" field="Email" matchMode="contains" [showMenu]="true"></p-columnFilter>
						</th>

						<!--VisiteeCount-->
						<th></th>
					</tr>

					<!--Column Names-->
					<tr style="height: 4rem">
						<!--INSERT CUSTOM COLUMNS HERE-->
						<th pSortableColumn="VisiteeName">Destination<p-sortIcon field="VisiteeName"></p-sortIcon></th>
						<th pSortableColumn="Email">Email<p-sortIcon field="Email"></p-sortIcon></th>
						<th pSortableColumn="VisiteeCount"># of visitors<p-sortIcon field="VisiteeCount"></p-sortIcon></th>
					</tr>
				</ng-template>

				<!--Data-->
				<ng-template pTemplate="body" let-Visitee>
					<tr [pSelectableRow]="Visitee">
						<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
							{{ Visitee[col.field] }}
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>

		<!--No Data-->
		<div *ngIf="loading == false && lstVisitee.length == 0" style="display: flex; justify-content: center; margin-top: 35px">
			<h4>No Visitors Today</h4>
		</div>
	</div>
</div>
